export const hostname = {
  prod: "support.srinternal.io",
  qa: "support.qa-smartrent.com",
  local: "localhost",
};
